// Máquina de estados · motor.md §1. Los guiones son datos, no código.
// LINEAL: pasos con id que son continuación natural (también reciben saltos).
export const LINEAL = ['a_adj', 'a_chk', 'a_cmp', 'a_firma', 'a_hand', 'b_hand', 'c_hand'];

export function loadCase(guiones, caseId) {
  const caso = guiones[caseId];
  const steps = caso.steps;
  const byId = {};
  steps.forEach((s, i) => {
    if (s.id) byId[s.id] = i;
  });
  return { id: caseId, caso, steps, byId };
}

export function nextLinear(mc, fromIdx) {
  for (let i = fromIdx + 1; i < mc.steps.length; i++) {
    const s = mc.steps[i];
    if (s.id && !LINEAL.includes(s.id)) continue; // rama: vive al final del array
    return i;
  }
  return -1;
}

export function resolveGo(mc, fromIdx, opt) {
  if (opt.go === 'end') return -1;
  if (opt.go != null) return mc.byId[opt.go] ?? -1;
  return nextLinear(mc, fromIdx);
}

// Paquete mínimo al asesor: sin edad, cédula, ingresos ni salud (agentes.md §F13/F30).
export function paqueteAsesor(caso) {
  return {
    disp: caso.disparador,
    prod: caso.producto,
    regla: 'Pedido explícito · hablar con una persona',
    datos: 'Lo conversado hasta este turno viaja en el log adjunto',
    res: 'La persona pidió hablar con un asesor de MBM desde el chat. No repite nada: el paquete viaja con la conversación.',
    sent: '—',
  };
}
